module.exports = __webpack_public_path__ + "static/media/varais-6.29dbbbee.jpg";